import { useCachedQuery } from "../../../hooks/useCachedQuery.ts";
import type { Board } from "../types.ts";
import { useBoardUuid } from "./useBoardUuid.ts";

export const useBoard = () => {
  const boardUuid = useBoardUuid();
  return {
    board: useCachedQuery<Board>({
      queryKey: `boards/${boardUuid}`,
    }),
  };
};
